export function ClockIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_30_537)">
        <path
          d="M7.99996 0C3.58171 0 0 3.58171 0 7.99996C0 12.4182 3.58171 15.9999 7.99996 15.9999C12.4182 15.9999 15.9999 12.4182 15.9999 7.99996C15.9952 3.58368 12.4163 0.00472097 7.99996 0ZM7.99996 14.8571C4.21288 14.8571 1.14284 11.787 1.14284 7.99996C1.14284 4.21288 4.21288 1.14284 7.99996 1.14284C11.787 1.14284 14.8571 4.21288 14.8571 7.99996C14.853 11.7854 11.7854 14.853 7.99996 14.8571Z"
          fill="#3D3D3D"
        />
        <path
          d="M8.44435 3.30151C8.12875 3.30151 7.87291 3.55735 7.87291 3.87295V7.87295H3.87295C3.55735 7.87295 3.30151 8.12878 3.30151 8.44439C3.30151 8.75999 3.55735 9.01579 3.87295 9.01579H8.44435C8.75995 9.01579 9.01579 8.75995 9.01579 8.44435V3.87295C9.01579 3.55735 8.75995 3.30151 8.44435 3.30151Z"
          fill="#3D3D3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_30_537">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
